import { SettingsKeys } from '@/i18n/types';

export const settings: Record<SettingsKeys, string> = {
  settings: 'Ajustes',
  account: 'Cuenta',
  profile: 'Perfil',
  preferences: 'Preferencias',
  theme: 'Tema',
  darkMode: 'Modo Oscuro',
  lightMode: 'Modo Claro',
  notifications: 'Notificaciones',
  privacy: 'Privacidad',
  termsOfService: 'Términos de Servicio',
  faq: 'Preguntas Frecuentes',
  support: 'Soporte',
  logout: 'Cerrar Sesión',
  deleteAccount: 'Eliminar Cuenta',
  confirmDeleteAccount: 'Confirmar Eliminación de Cuenta',
  userProfile: 'Perfil de Usuario',
  pleaseLoginToViewProfile: 'Por favor inicia sesión para ver tu perfil',
  authRequired: 'Autenticación Requerida',
  profileUpdated: 'Perfil Actualizado',
  profileSectionUpdated: 'La información de {section} se ha actualizado correctamente',
  updateError: 'Error de Actualización',
  couldNotUpdateProfile: 'No se pudo actualizar tu perfil',
  errorLoadingProfile: 'Error al Cargar el Perfil',
  tryRefreshPage: 'Por favor intenta actualizar la página',
  tryAgainLater: 'Por favor intenta de nuevo más tarde',
  identity: 'Identidad',
  contactInfo: 'Información de Contacto',
  security: 'Seguridad',
  supportAndHelp: 'Soporte y Ayuda',
  name: 'Nombre',
  email: 'Correo Electrónico',
  biography: 'Biografía',
  socialLinks: 'Enlaces de Redes Sociales',
  noSocialLinksAdded: 'No se han agregado enlaces sociales',
  website: 'Sitio Web',
  profileCompletion: 'Completado del Perfil',
  firstName: 'Nombre',
  lastName: 'Apellido',
  tellUsAboutYourself: 'Cuéntanos sobre ti...',
  saving: 'Guardando...',
  save: 'Guardar',
  phoneNumber: 'Número de Teléfono',
  phone: 'Teléfono',
  country: 'País',
  selectCountry: 'Seleccionar país',
  language: 'Idioma',
  selectLanguage: 'Seleccionar idioma',
  contactInfoUpdated: 'Información de contacto actualizada correctamente',
  couldNotUpdateContact: 'No se pudo actualizar la información de contacto',
  emailCannotBeChanged: 'La dirección de correo no se puede cambiar',
  optionalForSmsNotifications: 'Opcional, para notificaciones SMS',
  invalidPhoneNumber: 'Número de Teléfono Inválido',
  pleaseEnterValidPhone: 'Por favor ingresa un número de teléfono válido',
  identityInfoUpdated: 'Información de identidad actualizada correctamente',
  couldNotUpdateIdentity: 'No se pudo actualizar la información de identidad',
  changePassword: 'Cambiar Contraseña',
  currentPassword: 'Contraseña Actual',
  newPassword: 'Nueva Contraseña',
  confirmNewPassword: 'Confirmar Nueva Contraseña',
  passwordMismatch: 'Las Contraseñas No Coinciden',
  newPasswordsDoNotMatch: 'Las nuevas contraseñas no coinciden',
  passwordTooShort: 'Contraseña Demasiado Corta',
  passwordMinLength: 'La contraseña debe tener al menos 6 caracteres',
  changing: 'Cambiando...',
  passwordChanged: 'Contraseña Cambiada',
  passwordUpdatedSuccessfully: 'Tu contraseña ha sido actualizada correctamente',
  passwordChangeError: 'Error al Cambiar la Contraseña',
  couldNotChangePassword: 'No se pudo cambiar tu contraseña',
  twoFactorAuthentication: 'Autenticación de Dos Factores',
  twoFactorEnabled: 'Autenticación de Dos Factores Habilitada',
  twoFactorDisabled: 'Autenticación de Dos Factores Deshabilitada',
  twoFactorDescription: 'Agrega una capa adicional de seguridad a tu cuenta con la autenticación de dos factores',
  accountMoreSecure: 'Tu cuenta ahora es más segura con 2FA habilitado',
  twoFactorTurnedOff: 'La autenticación de dos factores ha sido desactivada',
  twoFactorError: 'Error de Autenticación de Dos Factores',
  couldNotToggleTwoFactor: 'No se pudo cambiar la autenticación de dos factores',
  securityRecommendation: 'Recomendación de Seguridad',
  enableTwoFactorRecommendation: 'Recomendamos habilitar la autenticación de dos factores para mejorar la seguridad de tu cuenta',
  loginHistory: 'Historial de Inicios de Sesión',
  loggingOut: 'Cerrando sesión...',
  logoutOtherSessions: 'Cerrar otras sesiones',
  logoutOtherSessionsConfirm: 'Sí, cerrar otras sesiones',
  logoutOtherSessionsConfirmation: 'Esto terminará todas las otras sesiones activas. Tu sesión actual seguirá activa.',
  otherSessionsClosed: 'Otras Sesiones Cerradas',
  successfullyLoggedOutOtherDevices: 'Se ha cerrado la sesión en todos los otros dispositivos',
  logoutError: 'Error al Cerrar Sesión',
  couldNotLogoutOtherSessions: 'No se pudo cerrar la sesión en otros dispositivos',
  current: 'Actual',
  errorFetchingSessions: 'Error al Obtener Sesiones',
  couldNotLoadSessionHistory: 'No se pudo cargar el historial de sesiones',
  notificationChannels: 'Canales de Notificación',
  emailNotifications: 'Notificaciones por Correo',
  smsNotifications: 'Notificaciones SMS',
  pushNotifications: 'Notificaciones Push',
  notificationEvents: 'Eventos de Notificación',
  messages: 'Mensajes',
  reminders: 'Recordatorios',
  promotionsAndNews: 'Promociones y Noticias',
  profileVisibility: 'Visibilidad del Perfil',
  public: 'Público',
  onlyContacts: 'Solo Contactos',
  private: 'Privado',
  publicDescription: 'Tu perfil es visible para todos',
  onlyContactsDescription: 'Tu perfil solo es visible para tus conexiones',
  privateDescription: 'Tu perfil no es visible para nadie',
  shareUsageData: 'Compartir Datos de Uso',
  shareUsageDataDescription: 'Ayúdanos a mejorar compartiendo datos de uso anónimos',
  allowAnalytics: 'Permitir Análisis',
  allowAnalyticsDescription: 'Permítenos recopilar análisis anónimos para mejorar nuestros servicios',
  appearance: 'Apariencia',
  systemDefault: 'Predeterminado del Sistema',
  fontSize: 'Tamaño de Fuente',
  selectFontSize: 'Seleccionar tamaño de fuente',
  small: 'Pequeño',
  medium: 'Mediano',
  large: 'Grande',
  preferencesUpdated: 'Preferencias Actualizadas',
  yourPreferencesHaveBeenSaved: 'Tus preferencias se han guardado correctamente',
  couldNotSavePreferences: 'No se pudieron guardar tus preferencias',
  savePreferences: 'Guardar Preferencias',
  currentPlan: 'Plan Actual',
  freePlan: 'Plan Gratuito',
  status: 'Estado',
  active: 'Activo',
  inactive: 'Inactivo',
  cancelling: 'Cancelando',
  paymentMethods: 'Métodos de Pago',
  noPaymentMethodsYet: 'Aún no hay métodos de pago agregados',
  addPaymentMethod: 'Agregar Método de Pago',
  expiresOn: 'Expira el',
  edit: 'Editar',
  billingHistory: 'Historial de Facturación',
  month: 'mes',
  free: 'Gratis',
  cancelSubscription: 'Cancelar Suscripción',
  cancelSubscriptionConfirmation: '¿Estás seguro de que quieres cancelar tu suscripción?',
  cancelSubscriptionWarning: 'Tu suscripción permanecerá activa hasta el final del período de facturación actual. Después de eso, perderás el acceso a las funciones premium.',
  processing: 'Procesando...',
  confirmCancellation: 'Sí, Cancelar Suscripción',
  subscriptionCancelled: 'Suscripción Cancelada',
  subscriptionWillEndOn: 'Tu suscripción terminará el {date}',
  cancellationError: 'Error de Cancelación',
  couldNotCancelSubscription: 'No se pudo cancelar tu suscripción',
  managePlan: 'Administrar Plan',
  upgradeToPremium: 'Actualizar a Premium',
  contactSupport: 'Contactar Soporte',
  subject: 'Asunto',
  selectSubject: 'Seleccionar un asunto',
  accountIssues: 'Problemas de Cuenta',
  billingInquiries: 'Consultas de Facturación',
  technicalSupport: 'Soporte Técnico',
  featureRequests: 'Solicitudes de Funciones',
  other: 'Otro',
  message: 'Mensaje',
  describeProblemOrQuestion: 'Describe tu problema o pregunta...',
  supportResponseTime: 'El soporte normalmente responde en 24 horas',
  sending: 'Enviando...',
  sendMessage: 'Enviar Mensaje',
  messageSent: 'Mensaje Enviado',
  supportTeamWillContactYou: 'Nuestro equipo de soporte te contactará pronto',
  feedback: 'Comentarios',
  positive: 'Positivo',
  negative: 'Negativo',
  whatDoYouLike: '¿Qué te gusta de nuestra aplicación?',
  whatCanWeImprove: '¿Qué podemos mejorar?',
  shareFavoriteFeatures: 'Comparte tus funciones o experiencias favoritas...',
  tellUsWhatToImprove: 'Dinos qué podemos mejorar...',
  submitting: 'Enviando...',
  submitFeedback: 'Enviar Comentarios',
  feedbackSubmitted: 'Comentarios Enviados',
  thanksForYourFeedback: '¡Gracias por tus comentarios!',
  howToChangePassword: '¿Cómo cambio mi contraseña?',
  changePasswordExplanation: 'Puedes cambiar tu contraseña en la pestaña Seguridad de tu página de Perfil. Necesitarás ingresar tu contraseña actual y luego tu nueva contraseña dos veces.',
  howToDeleteAccount: '¿Cómo puedo eliminar mi cuenta?',
  deleteAccountExplanation: 'Para eliminar tu cuenta, contacta con nuestro equipo de soporte. Todos tus datos serán eliminados permanentemente.',
  whatIsSubscriptionCancelPolicy: '¿Cuál es la política de cancelación de suscripciones?',
  subscriptionCancelPolicyExplanation: 'Puedes cancelar tu suscripción en cualquier momento. Tu suscripción permanecerá activa hasta el final del período de facturación actual.',
  canIExportMyData: '¿Puedo exportar mis datos?',
  exportDataExplanation: 'Sí, puedes exportar tus datos desde la página de configuración. Proporcionamos exportaciones en formatos comunes como CSV y PDF.',
  howToCreateNewBudget: '¿Cómo creo un nuevo presupuesto?',
  createNewBudgetExplanation: 'Navega a la sección de Finanzas, selecciona la pestaña Presupuestos y haz clic en el botón "Crear Nuevo Presupuesto".',
  isMyDataSecure: '¿Mis datos están seguros?',
  dataSecurityExplanation: 'Sí, utilizamos prácticas de seguridad y encriptación estándar de la industria para mantener tus datos seguros. Nunca compartimos tu información personal con terceros.',
  viewFullDocumentation: 'Ver Documentación Completa',
  // Nuevas traducciones para la monetización
  siteSettings: 'Configuración del Sitio',
  monetization: 'Monetización',
  monetizationDescription: 'Sube archivos requeridos para la monetización del sitio como ads.txt, archivos de verificación, etc.',
  uploadMonetizationFile: 'Subir Archivo de Monetización',
  selectFile: 'Seleccionar Archivo',
  chooseFile: 'Elegir archivo',
  fileUploadHint: 'Sube archivos como ads.txt, archivos de verificación de monetización, etc.',
  fileName: 'Nombre del Archivo (será visible en la raíz del sitio)',
  fileNameHint: 'Este será el nombre del archivo en la raíz de tu sitio: tudominio.com/nombre-archivo.txt',
  upload: 'Subir',
  uploading: 'Subiendo...',
  uploadSuccess: 'Subida exitosa',
  uploadError: 'Error de subida',
  fileAccessibleAt: 'Archivo accesible en',
  errorUploadingFile: 'Error al subir el archivo. Por favor intenta de nuevo.',
  pleaseSelectFile: 'Por favor selecciona un archivo y proporciona un nombre',
  
  // Nuevas traducciones para Features
  features: 'Características',
  featureManagement: 'Gestión de Características',
  featureKey: 'Clave',
  featureName: 'Nombre',
  featureDescription: 'Descripción',
  premiumFeature: 'Característica Premium',
  addFeature: 'Añadir Característica',
  editFeature: 'Editar Característica',
  deleteFeature: 'Eliminar Característica',
  deleteFeatureConfirm: '¿Estás seguro de que quieres eliminar esta característica? Esta acción no se puede deshacer.',
  featureCreated: 'Característica Creada',
  featureUpdated: 'Característica Actualizada',
  featureDeleted: 'Característica Eliminada',
  errorFetchingFeatures: 'Error al cargar las características',
  errorCreatingFeature: 'Error al crear la característica',
  errorUpdatingFeature: 'Error al actualizar la característica',
  errorDeletingFeature: 'Error al eliminar la característica',
  keyRequired: 'La clave es obligatoria',
  nameRequired: 'El nombre es obligatorio',
  keyAlreadyExists: 'Esta clave ya existe',
  manageFeatures: 'Gestionar Características',
  featureKeyTooltip: 'Identificador único usado en el código',
  featureNameTooltip: 'Nombre mostrado al usuario',
  featureDescriptionTooltip: 'Descripción de la funcionalidad',
  isPremiumTooltip: 'Indica si la característica es solo para usuarios premium',
};
